import axios from 'axios'

const state = {
    dashboard: null,
    wallet: null,
    shopRent: null,
    shoppers: null,
    itemStats: null,
    shopperRecords: null,
    donationsHistory: null,
    promotionRecords: null,
}

const getters = {
    dashboard (state) {
        return state.dashboard
    },
    wallet (state) {
        return state.wallet
    },
    shopRent (state) {
        return state.shopRent
    },
    shoppers (state) {
        return state.shoppers
    },
    itemStats (state) {
        return state.itemStats
    },
    shopperRecords (state) {
        return state.shopperRecords
    },
    donationsHistory (state) {
        return state.donationsHistory
    },
    promotionRecords (state) {
        return state.promotionRecords
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    // shop dashboard
    async fetchDashboard({ commit, getters }) {
        let userId = getters.user._id
        let response = await axios.get(`/dashboard/status/${userId}`)
        if(!response.data.error){
            return commit('SET_DASHBOARD', response.data.result) 
        }
        return response.data
    },

    // shop wallet
    async fetchWallet({ commit, getters }) {
        let userId = getters.user._id
        let response = await axios.get(`/wallet/balance/${userId}`)
        if(!response.data.error){
            return commit('SET_WALLET', response.data.result) 
        }
        return response.data
    },
    
    // shop shoppers
    async fetchShoppers({ commit, getters }) {
        let userId = getters.user._id
        let response = await axios.get(`/shoppers/mine/${userId}`)
        if(!response.data.error){
            return commit('SET_SHOPPERS', response.data.result) 
        }
        return response.data
    },
    
    // shopper records
    async fetchShopperRecords({ commit }, shopperObj) {
        let response = await axios.post('/shoppers/records', shopperObj)
        if(!response.data.error){
            return commit('SHOPPER_RECORDS', response.data.result) 
        }
        return response.data
    },
    
    // donations history
    async fetchDonationsHistory({ commit, getters }) {
        let userId = getters.user._id
        let response = await axios.get(`/donations/history/${userId}`)
        if(!response.data.error){
            return commit('DONATIONS_HISTORY', response.data.result) 
        }
        return response.data
    },
    
    // promotion records
    async fetchPromotionRecords ({ commit, getters }) {
        let userId = getters.user._id
        let response = await axios.get(`/shopPromotions/records/${userId}`)
        if(!response.data.error){
            return commit('PROMOTION_RECORDS', response.data.result) 
        }
        return response.data
    },
    
    // shop+ rent
    async fetchShopRent ({ commit, getters }) {
        let userAlphaCode = getters.user.alphaCode
        let response = await axios.get(`/shopPromotions/shopCost/${userAlphaCode}`)
        if(!response.data.error){
            return commit('SHOP_RENT', response.data.result) 
        }
        return response.data
    },
    
    // item statistics
    async fetchItemStats ({ commit }, itemId) {
        let response = await axios.get(`/itemStats/stats/${itemId}`)
        if(!response.data.error){
            return commit('ITEM_STATS', response.data.result) 
        }
        return response.data
    }

}

const mutations = {
    SHOP_RENT: (state, shopRent) => (state.shopRent = shopRent),
    SET_WALLET: (state, wallet) => (state.wallet = wallet),
    ITEM_STATS: (state, itemStats) => (state.itemStats = itemStats),
    SET_SHOPPERS: (state, shoppers) => (state.shoppers = shoppers),
    SET_DASHBOARD: (state, dashboard) => (state.dashboard = dashboard),
    SHOPPER_RECORDS: (state, shopperRecords) => (state.shopperRecords = shopperRecords),
    DONATIONS_HISTORY: (state, donationsHistory) => (state.donationsHistory = donationsHistory),
    PROMOTION_RECORDS: (state, promotionRecords) => (state.promotionRecords = promotionRecords),
}

export default {
    state,
    getters,
    actions,
    mutations
}